import * as contract_storage from '@/storage/contract.js'

import * as toast from '@/components/ui/toast.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Dialog from '@/components/ui/dialog.tsx'




export async function delete_ (_id: string): Promise<void>
{
	try
	{
		await contract_storage.delete_(_id)

		toast.success('在职员工合同已重置')

		Dialog.close()

	}

	catch (e)
	{
		toast.error(e as Error)

	}

}

export default function (_id: string, name: string): void
{
	let message = `确定要重置在职员工「${name}」的合同吗？此操作不可撤销。`

	let on_delete = (): void =>
	{
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		delete_(_id)

	}

	Dialog.alert(
		<p>{message}</p>,

		{ size: 'lg', title: '重置合同', confirm: on_delete },

	)

}
